import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { deviceDetect } from 'react-device-detect';
import Cookies from 'universal-cookie';

import { LayoutContent } from './Content';
import AppLocale from '../../lngProvider';
import useAnalyzer from '../../hooks/useAnalyzer';
import { THEME_COOKIES_KEY, THEME_TYPE } from '../../commons/constants';
import useDocumentVisibleChange from '../../hooks/useDocumentVisibleChange';
import useLanguage from '../../hooks/useLanguage';
import { storeName } from '../../redux/models/layout.model';

import { getProject } from '../../redux/selectors/project.selector';
import { getHashParams } from '../../utils';
import { storeName as projectStoreName } from '../../redux/models/project.model';
import ChatWithAI from '../../commons/components/ChatWithAI';
import { useLayout } from '../../hooks/useShareLink/layout';

import './styles.scss';

const Layout: FC = () => {
  useAnalyzer();

  const device = deviceDetect(window.navigator.userAgent);
  const cookies = new Cookies();
  useDocumentVisibleChange();
  useLanguage();
  useLayout();

  const [themeKey, setThemeKey] = useState<string>(THEME_TYPE.LIGHT.key);

  const locale = useSelector((state) => state[storeName].locale);
  const dispatch = useDispatch()[storeName];
  const projectDispatch = useDispatch()[projectStoreName];
  const project = useSelector(getProject);

  useEffect(() => {
    const hasParams = getHashParams();
    if (hasParams && Object.keys(hasParams).includes('vt')) {
      projectDispatch.setIframeContent({
        visible: true,
        url: hasParams['vt'],
      });
    }
  }, [project]);

  useEffect(() => {
    let { key } = THEME_TYPE.LIGHT;
    const themeCookies: string = cookies.get(THEME_COOKIES_KEY);
    if (!themeCookies) {
      // TODO: not need using set theme to cookies right now
      // key = THEME_TYPE.DARK.key;
      // cookies.set(THEME_COOKIES_KEY, key, { path: '/' });
    } else {
      key = themeCookies;
    }

    setThemeKey(key);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-syntax
    if (device.isTablet || (device.isBrowser && 'ontouchend' in document)) {
      dispatch.setTabletDevice(true);
      return;
    }

    if (device.isMobile) {
      dispatch.setMobileDevice(true);
    }
  }, [device]);

  if (!locale) return null;
  const currentAppLocale = AppLocale[locale.locale];
  return (
    <>
      {!!project?.hasAIQuestion && <ChatWithAI />}
      <IntlProvider
        key={locale.locale}
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <LayoutContent themeKey={themeKey} />
      </IntlProvider>
    </>
  );
};

export default Layout;
